import { createApiSlice } from "@common";
import {
    MY_INFO_EDUCATION_DETAILS
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addEmployeeEducationalDetails",
        method: "post",
        url: MY_INFO_EDUCATION_DETAILS,
        stateKey: "message",
    },
    {
        name: "getEmployeeEducationalDetails",
        method: "get",
        url: MY_INFO_EDUCATION_DETAILS,
        stateKey: "data",
    },
    {
        name: "updateEmployeeEducationalDetails",
        method: "put",
        url: MY_INFO_EDUCATION_DETAILS,
        stateKey: "message",
    },
    {
        name: "deleteEmployeeEducationalDetails",
        method: "delete",
        url: MY_INFO_EDUCATION_DETAILS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "EmployeeEducationalDetails",
    apiConfig,
    customReducers,
);
const EmployeeEducationalDetailsSlice = slice;
// Export the slice's reducer
export default EmployeeEducationalDetailsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addEmployeeEducationalDetails,
    getEmployeeEducationalDetails,
    updateEmployeeEducationalDetails,
    deleteEmployeeEducationalDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
